import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_setPrintSettingAddItemFlag, fn_getPrintSettingAddItemFlag,
    fn_setPrintDelete, fn_setPrintSheetChangeDown, fn_setPrintSheetChangeUp, fn_setTestPrint
} from "../../../../../function/FnBodySetting";

@observer
class SettingEtcPrinterSetItemAddView extends Component {

    render() {
        const { rootStore, obj, index } = this.props;

        return (
            <>
                <li className={obj.useYn === "Y" ? "use active" : ""} id={"printAdd" + index}>
                    <div className="print_name">
                        <div className="name">
                            <strong>{(obj.printerName.length > 0 ? obj.printerName : "프린터명없음")}</strong>
                            <input type="checkbox" id={index} className="inp"
                                checked={obj.useYn === "Y" ? true : false}
                                onChange={() => {
                                    fn_setPrintSettingAddItemFlag(rootStore, !fn_getPrintSettingAddItemFlag(rootStore, index), index);
                                }}
                            />
                            <label className="lab_toggle" htmlFor={index}></label>
                        </div>
                        <div className="port">
                            <span>연결포스: {(rootStore.searchStore.getSession.connPosNo).trim()}</span>
                            <span>연결포트: {(obj.portNo).trim()}</span>
                            <span>출력속도: {(obj.baudRate).trim()}</span>
                        </div>
                        <div className="btn">
                            <button type="button" onClick={event => { document.getElementById('printAdd' + index).classList.toggle('active') }}></button>
                        </div>
                    </div>
                    <div className="print_cont">
                        <div className="setting">
                            <div className="tit">주문전표 (고객용)</div>
                            <div className="desc">출력양식: 주문메뉴 + 요청사항 + 배달주소 + 원산지  </div>
                            <div className="change">
                                <button type="button" className="btn_m"
                                    onClick={event => {
                                        event.preventDefault();
                                        if (obj.customerSheet > 0) {
                                            fn_setPrintSheetChangeDown(rootStore, "add", "customerSheet", index)
                                        }
                                    }}
                                ><span className={obj.customerSheet == 0 ? "min_disabled" : ""}></span></button>
                                <strong>{(obj.customerSheet == 0 ? "미출력" : obj.customerSheet + "장")}</strong>
                                <button type="button" className="btn_p"
                                    onClick={event => {
                                        event.preventDefault();
                                        fn_setPrintSheetChangeUp(rootStore, "add", "customerSheet", index)
                                    }}
                                ><span></span></button>
                            </div>
                        </div>
                        <div className="setting">
                            <div className="tit">주문서 (매장용)</div>
                            <div className="desc">출력양식: 주문메뉴 + 요청사항</div>
                            <div className="change">
                                <button type="button" className="btn_m"
                                    onClick={event => {
                                        event.preventDefault();
                                        if (obj.shopSheet > 0) {
                                            fn_setPrintSheetChangeDown(rootStore, "add", "shopSheet", index)
                                        }
                                    }}
                                ><span className={obj.shopSheet == 0 ? "min_disabled" : ""}></span></button>
                                <strong>{(obj.shopSheet == 0 ? "미출력" : obj.shopSheet + "장")}</strong>
                                <button type="button" className="btn_p"
                                    onClick={event => {
                                        event.preventDefault();
                                        fn_setPrintSheetChangeUp(rootStore, "add", "shopSheet", index)
                                    }}
                                ><span></span></button>
                            </div>
                        </div>
                        <p className="txt">
                            <span>프린터 연결이 되었는지 테스트 출력을 통해 확인하세요</span>
                            <button type="button" className="btn_print" onClick={event => { obj.useYn === "Y" ? fn_setTestPrint(rootStore, 'P', 'etc', obj.portNo, obj.baudRate, "") : "" }}>
                                <span className="ico">테스트 출력</span>
                            </button>
                        </p>

                        <button type="button" className="btn_cancel" onClick={() => fn_setPrintDelete(rootStore, index)}>
                            <strong>프린터 삭제</strong><input type="text" className="hide" id="print_delete" value={index} readOnly={true} />
                        </button>
                    </div>
                </li>
            </>
        )
    }
}

export default SettingEtcPrinterSetItemAddView;